import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'account_details_page' */ './AccountDetailsPage'),
);
